import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("BITZX render error:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-[#0a0b0d] text-white flex items-center justify-center p-8">
          <div className="max-w-lg rounded-2xl border border-red-500/40 bg-[#12141a] p-8">
            <h1 className="text-xl font-bold text-red-400 mb-3">Page failed to load</h1>
            <p className="text-[#9A9B9F] text-sm mb-4">
              The site hit a JavaScript error. Try a hard refresh (Ctrl+F5). If this
              continues, contact support with the message below.
            </p>
            <pre className="text-xs text-[#EBD38D] whitespace-pre-wrap break-words bg-[#0a0b0d] p-4 rounded-lg border border-[#2a2d35]">
              {this.state.error?.message || String(this.state.error)}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
